<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Goods/index.html')">商品管理</div></el-breadcrumb-item>
			<el-breadcrumb-item>商品分类</el-breadcrumb-item>
		</el-breadcrumb>

		<el-form :inline="true" :model="item" class="search">
			<el-form-item label="分类名称">
				<el-input v-model="item.name" placeholder="请输入分类名称" size="small"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit" size="medium">查询</el-button>

			</el-form-item>
		</el-form>
		<div class="btns">
			<el-button type="primary" size="small" @click="add" v-auth="['supplier/productCategory/add']">添加分类</el-button>
			<el-button type="danger" size="small" @click="delAll" v-auth="['supplier/productCategory/delete']">批量删除</el-button>

		</div>

		<el-table ref="table" :data="list" border stripe highlight-current-row
		@selection-change="handleSelectionChange" row-key="id" lazy
			:load="load" :tree-props="{children: 'children', hasChildren: 'children_count'}">
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>

			<el-table-column prop="name" label="分类名称"></el-table-column>
			<el-table-column prop="parent_idName" label="上级分类">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;" v-if="scope.row.parent">
						{{scope.row.parent.name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="分类图标">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;" v-if="scope.row.logo">
						<img :src="scope.row.logo" height="30" style="display: flex; margin-right: 5px;" />
					</div>
				</template>
			</el-table-column>
<!--			<el-table-column prop="level" label="所在层级" align="center" width="100"></el-table-column>-->
			<el-table-column prop="orders" label="排序号" align="center" width="100"></el-table-column>
			<el-table-column  label="所属行业" align="center">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;" v-if="scope.row.industry">
						{{scope.row.industry.name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="last_modified_date" label="更新时间" align="center"></el-table-column>

			<el-table-column label="操作" width="160" align="center">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['supplier/productCategory/edit']">编辑</el-button>
					<el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row)" class="l10" v-auth="['supplier/productCategory/delete']">
						<el-button size="mini" type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination> -->
	</div>
</template>
<script>
	export default {
		name: 'index',
		data() {
			return {
				list: [],
				isLoad: false,
				pageSize: 20,
				total: 0,
				page: 1,
				number: 0,
				// 查询
				item: {}
			}
		},
		created() {
			this.loadList()
		},
		methods: {
			gotopage(url){
			     var link =  this.$router.resolve({
			     path: url
			   });
			   window.open(link.href, '_blank')
			},
			loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				// 树形数据 有children来标识
				this.axios.post('/supplier/productCategory/listTreeByPid', {
						name: this.item.name
					})
					.then(res => {
						this.isLoad = !this.isLoad
						// 获取数据
						this.list = res.data.list.data
						// 页数 page
						this.total = res.data.list.total
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			load(tree, treeNode, resolve) {
				//1415567502557691905
				this.loadItem = []
				this.axios.post('/supplier/productCategory/listTreeByPid', {
						parent_id: tree.id
					})
					.then(res => {
						// 获取数据
						this.list1 = res.data.list.data
						this.loadItem = this.list1
						// 页数 page
						// this.total = res.data.total
						resolve(this.loadItem)
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			// 跳转到edit添加
			add() {
				this.$router.push({
					path: '/Category/add.html'
				});
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Category/edit.html',
					query: {
						id: id
					}
				});
			},

			//
			del(scope) {
				let id = scope.id
				let parentIds = scope.parentId
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.delete('/supplier/productCategory/delete', {
						data: {
							ids: id
						}
					})
					.then(() => {
						this.isLoad = !this.isLoad

						this.$message.success({
							message: '删除成功',
							showClose: false
						});
						this.loadList()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			delAll() {
				let id = []
				let parentIds = []
				let arrRefs = this.$refs.table.store.states.lazyTreeNodeMap
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					parentIds.push(item.parentId)
					id.push(item.id)
				}

				// let arrRefs = this.$refs.table.store.states.lazyTreeNodeMap
				// let arrParent = arrRefs[parentIds]
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				//  删除接口中的值
				this.axios.delete('/supplier/productCategory/delete', {
					data: {
						ids: id
					}
				}).then(() => {
					this.isLoad = !this.isLoad

					// 删除数组中的值
					parentIds.forEach((key, index) => {
						let arrParent = arrRefs[key]
						if (arrParent) {
							arrParent.forEach((key, index) => {
								if (id.indexOf(key.id) != -1) {
									arrParent.splice(index, 1);
								}
							})
						}
					})

					this.$message.success({
						message: '删除成功',
						showClose: false
					});
					this.loadList()
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			// 搜索查询
			submit() {
				// this.item.page = 1
				this.loadList()
			},
			// 导出
			excelOut() {
				return;
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('', {
						params: {
							nickname: this.item.nickname,
							title: this.item.title
						}
					})
					.then(res => {
						this.isLoad = !this.isLoad
						// 导出
						window.open(res.url)
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			}
		}
	}
</script>
<style scoped>
</style>
